import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-general-error',
    standalone: true,
    imports: [CommonModule, IonicModule, TranslateModule],
    templateUrl: './general-error.component.html',
    styleUrl: './general-error.component.scss',
})
export class GeneralErrorComponent {
    @Input() code!: string | null;
    @Input() type!: 'warning' | null;
    constructor() {}
}
